import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { User } from '@app/models/user-data';
import { Endpoint } from '@app/constants/endpoints.constants';
import { ILink } from '@app/models/links';

@Injectable({
  providedIn: 'root'
})
export class AuthRepoService {
  constructor(private _httpClient: HttpClient) {}

  getUserData(): Observable<User | undefined> {
    return this._httpClient.get<User>(Endpoint.CurrentUser);
  }

  updateCache(): Observable<undefined> {
    return this._httpClient.post<undefined>(Endpoint.UpdateCache, {});
  }

  getConstants(): Observable<ILink[]> {
    return this._httpClient.get<ILink[]>(Endpoint.Constants);
  }
}
